<div style="padding-top: 4.5em; overflow: hidden;">
    <div id="tableauTag"></div> 
</div>
